export interface OverviewChartConfig {
  id: string;
  label: string;
}

export interface OverviewSectionConfig {
  id: string;
  label: string;
  charts: OverviewChartConfig[];
}

export const OVERVIEW_SECTIONS: OverviewSectionConfig[] = [
  {
    id: 'equity_index',
    label: 'Climate Equity Index',
    charts: [
      { id: 'burdens', label: 'Burdens' },
      { id: 'benefits', label: 'Benefits' },
      { id: 'livability_rankings_2023', label: 'Climate Equity Rankings (2023)' },
      { id: 'livability_over_time', label: 'Climate Equity Over Time' }
    ]
  },
  {
    id: 'buildings',
    label: 'Buildings & Energy',
    charts: [
      { id: 'electricity_consumption', label: 'Electricity Consumption' },
      { id: 'natural_gas_consumption', label: 'Natural Gas Consumption' },
      { id: 'cumulative_solar_capacity', label: 'Cumulative Solar Capacity' }
    ]
  },
  {
    id: 'transportation',
    label: 'Transportation',
    charts: [
      { id: 'vehicle_miles', label: 'Vehicle Miles' },
      { id: 'mode_share', label: 'Mode Share' },
      { id: 'ev_fleet_adoption', label: 'EV Fleet Adoption' }
    ]
  },
  {
    id: 'waste',
    label: 'Waste +',
    charts: [
      { id: 'waste_tonnage', label: 'Waste Tonnage' },
      { id: 'landfill_emissions', label: 'Landfill Emissions' }
    ]
  },
  {
    id: 'people_equity',
    label: 'People & Equity',
    charts: [
      { id: 'income_by_race', label: 'Income by Race' },
      { id: 'housing_burden', label: 'Housing Burden' }
    ]
  },
  {
    id: 'ghg_inventory',
    label: 'GHG Inventory',
    charts: [
      { id: 'sector_based_ghg', label: 'Sector-Based GHG Inventory' },
      { id: 'consumption_based_ghg', label: 'Consumption-Based GHG Inventory' }
    ]
  }
];
